var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("div", [_vm._v("Loading Recently Watched Lessons...")])
        : _vm._e(),
      _vm._v(" "),
      _vm.slides.length > 0
        ? _c(
            "VueSlickCarousel",
            _vm._b({}, "VueSlickCarousel", _vm.settings, false),
            _vm._l(_vm.slides, function (slide) {
              return slide.tutorial !== null && slide.tutorial.hidden !== 1
                ? _c("div", { key: slide.id }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "tutorial/" +
                            slide.tutorial.slug +
                            "/" +
                            slide.lesson.tutorial_order,
                        },
                      },
                      [
                        _c("div", { staticClass: "slide-frame" }, [
                          _c("div", { staticClass: "days-ago" }, [
                            _c("span", [
                              _vm._v(
                                "Lesson " + _vm._s(slide.lesson.tutorial_order)
                              ),
                            ]),
                            _vm._v(
                              ",\n                        " +
                                _vm._s(_vm.convertDate(slide.created_at)) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src:
                                "/storage/tutorial_thumbnails/" +
                                slide.tutorial.thumbnail,
                            },
                          }),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }